import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import type RouterService from '@ember/routing/router-service';

// The bare URL has no page of its own (an empty outlet), so land on enrollment, whose own guard redirects further.
export default class AuthenticatedSlrLrapIndexRoute extends Route {
  @service declare router: RouterService;

  redirect(_model?: unknown, transition?: Transition) {
    this.router.replaceWith('authenticated.slr.lrap.enrollment', {
      queryParams: transition?.to?.queryParams ?? {},
    });
  }
}
